import ProgressionImg from "../../images/who-we-are/progresion.png";
import WorkoutImg from "../../images/who-we-are/workout.png";
import NutritionImg from "../../images/who-we-are/nutritions.png";

export const cardList = [
  {
    img: ProgressionImg,
    title: "Progression",
    description:
      "Our team of experts will work with you to create a customized plan that helps you achieve success one step at a time.",
  },
  {
    img: WorkoutImg,
    title: "Workout",
    description:
      " With a variety of workouts to choose from, you'll have everything you need to get into the best shape of your life.",
  },
  {
    img: NutritionImg,
    title: "Nutritions",
    description:
      "Our team will work with you to create a personalized meal plan that helps you reach your specific health goals.",
  },
];
